<template>
  <article class="over-vecozo-overview">
    <div class="container">
      <HeroesMainHero
        v-if="hero && (hero.title?.value || hero.body?.value)"
        :main-hero="{
          intro: {
            icon: hero.icon ?? null,
            title: hero.title ?? null,
            body: hero.body ?? null,
          },
          img: hero.image,
          article: hero.links,
        }" />
    </div>
    <div class="container">
      <div class="content-block-full">
        <BlocksWerkenbijContentArea v-if="rows" :content="rows" />
      </div>
    </div>
  </article>
</template>

<script lang="ts" setup>
import type { AboutUsPageResponseModel, ContentResponseModel } from '@api';

const props = defineProps<{ data: ContentResponseModel }>();
const { hero, rows } = props.data.content as AboutUsPageResponseModel;
</script>
